import React, { Component } from "react";
import { FloatingForm } from "../../../../components/common/Converter";
import CardView from "../../../../components/common/CardView";

import Table from "../../../../components/Table";
import { Button } from "nq-component";
import {
  findObjectUseCase,
  countObjectUseCase,
  deleteObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import BaseListPage from "../../../../base/BaseListPage";
import { InfiniteScroll } from "nq-component";
import SalaryAdjustmentPresenter from "./SalaryAdjustmentPresenter";
import Progress from "../../../../components/Progress";

export default class SalaryAdjustmentPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new SalaryAdjustmentPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );

    this.state = {
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "service_record";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleCancel = () => {
    this.props.closeModal();
  };

  generateCSV() {
    const { data } = this.props;
    const { objects } = this.state;

    this.presenter.getGeneratedCSV(data, objects);
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current } = this.state;
    if (!schema) return <Progress />;

    console.log("OBJECTS", objects);

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "from" &&
        fields !== "to" &&
        fields !== "designation" &&
        fields !== "status" &&
        fields !== "salary" &&
        fields !== "station" &&
        fields !== "branch" &&
        fields !== "leave" &&
        fields !== "date" &&
        fields !== "cause"
    );

    return (
      <>
        <FloatingForm width="75rem">
          <CardView style={{ padding: 0 }}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="overflow-auto">
                <InfiniteScroll
                  className="h-100"
                  loadMore={this.loadMore.bind(this)}
                >
                  <div className="p-3 p-lg-4">
                    <div
                      style={{
                        marginTop: "10px",
                        width: "100%",
                      }}
                    ></div>
                    <div className="d-flex align-items-center">
                      <div
                        className="d-flex gap-2"
                        style={{ marginLeft: "auto" }}
                      >
                        <Button onClick={this.generateCSV.bind(this)}>
                          Generate CSV
                        </Button>
                      </div>
                    </div>
                    <br></br>

                    <Table
                      progress={loading}
                      fields={schema.fields}
                      objects={objects}
                      collection={schema}
                      count={count}
                      limit={limit}
                      current={current}
                      loadPagination={this.onClickPagination.bind(this)}
                      excludeFields={Object.keys(schema.fields).reduce(
                        (acc, key) => {
                          const options = schema.fields[key];
                          if (options.read === false) {
                            acc.push(key);
                          }
                          switch (options._type || options.type) {
                            case "Relation":
                            case "Array":
                            case "Object":
                            case "File":
                              acc.push(key);
                              break;
                            default:
                          }
                          return acc;
                        },
                        ["Id", "Created At", "Updated At", ...includeLabel]
                      )}
                      onClickItem={this.onClickItem.bind(this)}
                    />
                  </div>
                </InfiniteScroll>
              </div>
              <br></br>
              <div className="w-100 d-flex justify-content-end gap-2 mb-3 pe-3">
                <Button className="btn btn-light" onClick={this.handleCancel}>
                  Cancel
                </Button>
              </div>
            </form>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
